import _ from 'lodash';
import { getBaseContentUrl } from 'helpers/ApiHelper';

export const getEmailSubmissionBody = email => {
  if (!email) return {};
  return {
    email,
    prospect: 'fxplus',
  };
};

export const getEmailSubmissionUrl = pathKey => {
  const authConfig = _.get(window.ExternalConfig, 'api.auth');
  const uri = _.get(authConfig, pathKey);
  return `${getBaseContentUrl()}${uri}`;
};
